import { api } from '@/scripts/api';

export const FileService = {

    post(payload, queries= {}) {

        return new Promise((resolve, reject) => {
            const queryParams =[];
            for (const key in queries) {
                if (Object.prototype.hasOwnProperty.call(queries, key)) {
                    queryParams.push(`${key}=${queries[key]}`) ;
                }
            }
            const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
            const service  = `/api/Files${queryString}`;

            api.post(service, payload)
                .then(resolve)
                .catch(reject)

        });
    },

}
